import React from "react";

import "../assets/Footer.scss";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer__content">
        <p>
          This layout is inspired by work I contributed to professionally,
          recreated here with original code to demonstrate my skills.
        </p>
      </div>
    </div>
  );
}
